import styled from 'styled-components';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { themeColor, themeMediaQuery } from '@utils/styledTheme.util';
import { TextPairing } from '@components/TextPairing';

export const SectionWrapper = styled(Box)``;

export const TextBox = styled(Box)`
  height: 220px;
  position: relative;
  background: linear-gradient(0deg, #f9f6f1 0%, rgba(249, 245, 240, 0) 85%);
  ${themeMediaQuery('below_sm')} {
    height: 250px;
  }
`;

export const TextWrapper = styled(Box)`
  position: absolute;
  left: 50%;
  top: 75px;
  transform: translate3d(-50%, 0, 0);
  ${themeMediaQuery('below_sm')} {
    top: 44px;
    width: 80%;
  }
`;

export const StyledFlex = styled(Flex)`
  width: fit-content;
  margin: auto;
`;

export const StyledTextPairing = styled(TextPairing)`
  text-align: center;
  display: block;
  .text-pairing-body {
    margin: auto;
  }
  a {
    color: ${themeColor('linkDefault')};
  }
  a:hover {
    color: ${themeColor('linkHover')};
  }
`;

export const SectionContainer = styled(Box)<{
  backgroundImage: string;
}>`
  background: linear-gradient(180deg, #f9f6f1 0%, rgba(249, 245, 240, 0) 85%),
    url(${props => cloudAssetUrl(props.backgroundImage, { optimization: 'mild', isResizeDisabled: true })});
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  width: 100vw;
  height: 36vw;
  display: flex;
  justify-content: center;
  ${themeMediaQuery('below_sm')} {
    height: 326px;
  }
`;
